import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 1,
  "data-testid": "doctor-contact-email",
  class: "font-normal text-gray-400"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 1,
  "data-testid": "doctor-contact-phone",
  class: "font-normal text-gray-400"
}
const _hoisted_6 = { "data-testid": "doctor-contact-location" }

import { computed } from 'vue'
import { mdiEmailOutline, mdiPhoneOutline, mdiMapMarkerOutline } from '@mdi/js'

import type { DoctorDetailResponse } from '@/Network/Types/Responses/CompanyResponses'
import DetailCard from '../atoms/DetailCard.vue'
import DetailField from '../atoms/DetailField.vue'
import { formatPhone } from '@/utils/formatters'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactPanel',
  props: {
    doctor: {}
  },
  setup(__props: any) {

const props = __props;



const email = computed(() => props.doctor.doctor.user?.email || null)
const rawPhone = computed(() => props.doctor.doctor.user?.mainPhone?.phoneNumber || null)
const phone = computed(() => (rawPhone.value ? formatPhone(rawPhone.value) : null))
const phoneDigits = computed(() => rawPhone.value?.replace(/\D/g, '') ?? '')
const city = computed(() => props.doctor.doctor.user?.mainAddress?.city)
const uf = computed(() => props.doctor.doctor.user?.mainAddress?.state)

const location = computed(() => {
  if (city.value && uf.value) return `${city.value} - ${uf.value}`
  return city.value || uf.value || ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DetailCard, { title: "Contato" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DetailField, {
          icon: _unref(mdiEmailOutline),
          label: "E-mail"
        }, {
          default: _withCtx(() => [
            (email.value)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: `mailto:${email.value}`,
                  "data-testid": "doctor-contact-email",
                  class: "text-primary30 hover:underline"
                }, _toDisplayString(email.value), 9, _hoisted_2))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, " Não informado "))
          ]),
          _: 1
        }, 8, ["icon"]),
        _createVNode(DetailField, {
          icon: _unref(mdiPhoneOutline),
          label: "Telefone"
        }, {
          default: _withCtx(() => [
            (phone.value)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: `tel:${phoneDigits.value}`,
                  "data-testid": "doctor-contact-phone",
                  class: "text-primary30 hover:underline"
                }, _toDisplayString(phone.value), 9, _hoisted_4))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, " Não informado "))
          ]),
          _: 1
        }, 8, ["icon"]),
        (location.value)
          ? (_openBlock(), _createBlock(DetailField, {
              key: 0,
              icon: _unref(mdiMapMarkerOutline),
              label: "Localização"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(location.value), 1)
              ]),
              _: 1
            }, 8, ["icon"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})